import { TagIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import dubaiSkyline from "../assests/images/dubai-skyline.webp"

export default function LimitedTimeOffer() {
    const navigate = useNavigate();

    return (
        <section
            className="
                w-full
                bg-[#F7F5EF]
                py-7
                sm:py-9
                lg:py-11
            "
        >
            <div
                className="
                    mx-auto
                    max-w-[1440px]
                    px-5
                    sm:px-8
                    lg:px-12
                    xl:px-16
                "
            >
                {/* =====================================================
                    OFFER BANNER
                ===================================================== */}
                <div
                    className="
                        group
                        relative
                        min-h-[215px]
                        w-full
                        overflow-hidden
                        rounded-[16px]
                        bg-[#073F3D]
                        shadow-[0_12px_35px_rgba(7,63,61,0.12)]
                        sm:min-h-[225px]
                        lg:min-h-[220px]
                    "
                >

                    {/* =================================================
                        DUBAI IMAGE
                    ================================================= */}

                    <div
                        className="
                            absolute
                            inset-y-0
                            right-0
                            z-0
                            w-full
                            sm:w-[65%]
                            lg:w-[70%]
                        "
                    >
                        <img
                            src={dubaiSkyline}
                            alt="Dubai skyline"
                            className="
                                absolute
                                inset-0
                                h-full
                                w-full
                                object-cover
                                object-center
                                transition-transform
                                duration-[1200ms]
                                ease-out
                                group-hover:scale-[1.04]
                            "
                        />

                        {/* Image overlay */}
                        <div
                            className="
                                absolute
                                inset-0
                                bg-gradient-to-r
                                from-[#073F3D]
                                via-[#073F3D]/45
                                to-transparent
                            "
                        />

                        {/* Bottom overlay */}
                        <div
                            className="
                                absolute
                                inset-0
                                bg-gradient-to-t
                                from-[#073F3D]/45
                                via-transparent
                                to-transparent
                            "
                        />
                    </div>


                    {/* =================================================
                        LEFT COLOR PANEL
                    ================================================= */}

                    <div
                        className="
                            absolute
                            inset-y-0
                            left-0
                            z-[1]
                            w-full
                            bg-gradient-to-r
                            from-[#073F3D]
                            via-[#073F3D]/95
                            to-transparent
                            sm:w-[68%]
                            lg:w-[62%]
                        "
                    />


                    {/* =================================================
                        GOLD DECORATIVE GLOW
                    ================================================= */}

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -right-24
                            -top-32
                            z-[2]
                            h-80
                            w-80
                            rounded-full
                            bg-[#D5A33C]/10
                            blur-3xl
                            transition-all
                            duration-700
                            group-hover:bg-[#D5A33C]/15
                        "
                    />


                    {/* =================================================
                        CONTENT
                    ================================================= */}

                    <div
                        className="
                            relative
                            z-10
                            flex
                            min-h-[215px]
                            w-full
                            items-center
                            px-6
                            py-8
                            sm:min-h-[225px]
                            sm:px-8
                            lg:min-h-[220px]
                            lg:px-10
                            xl:px-12
                        "
                    >

                        <div
                            className="
                                max-w-[600px]
                            "
                        >

                            {/* =================================================
                                LABEL
                            ================================================= */}

                            <div
                                className="
                                    mb-3
                                    flex
                                    items-center
                                    gap-2.5
                                "
                            >
                                <div
                                    className="
                                        flex
                                        h-8
                                        w-8
                                        shrink-0
                                        items-center
                                        justify-center
                                        rounded-full
                                        bg-[#E8D7AA]
                                    "
                                >
                                    <TagIcon
                                        className="
                                            h-4
                                            w-4
                                            text-[#0B5552]
                                        "
                                        strokeWidth={1.8}
                                    />
                                </div>

                                <span
                                    className="
                                        text-[9px]
                                        font-semibold
                                        uppercase
                                        tracking-[0.2em]
                                        text-[#E5C56D]
                                        sm:text-[10px]
                                    "
                                >
                                    Limited Time Offer
                                </span>
                            </div>


                            {/* =================================================
                                TITLE
                            ================================================= */}

                            <h2
                                className="
                                    max-w-[520px]
                                    font-serif
                                    text-[26px]
                                    font-medium
                                    leading-[1.12]
                                    tracking-[-0.015em]
                                    !text-white
                                    sm:text-[30px]
                                    lg:text-[32px]
                                    xl:text-[35px]
                                "
                            >
                                Save Up to 40% on Your
                                <br />

                                <span className="text-[#E5C56D] italic">
                                    Dubai Stay
                                </span>
                            </h2>


                            {/* =================================================
                                DESCRIPTION
                            ================================================= */}

                            <p
                                className="
                                    mt-2
                                    max-w-[450px]
                                    text-[10px]
                                    leading-[1.7]
                                    text-white/70
                                    sm:text-[11px]
                                    lg:text-xs
                                "
                            >
                                Book now and enjoy exclusive deals on
                                luxury hotels and unforgettable stays
                                across Dubai.
                            </p>


                            {/* =================================================
                                CTA
                            ================================================= */}

                            <button
                                type="button"
                                onClick={() => navigate("/offers")}
                                className="
                                    group/button
                                    mt-5
                                    inline-flex
                                    items-center
                                    gap-2.5
                                    rounded-full
                                    bg-[#D5A33C]
                                    px-5
                                    py-2.5
                                    text-[10px]
                                    font-semibold
                                    text-[#173F3E]
                                    shadow-[0_5px_15px_rgba(0,0,0,0.12)]
                                    transition-all
                                    duration-300
                                    hover:bg-[#E3B956]
                                    hover:shadow-[0_8px_20px_rgba(0,0,0,0.18)]
                                    active:scale-[0.98]
                                "
                            >
                                <span>
                                    View Offers
                                </span>

                                <ArrowRightIcon
                                    className="
                                        h-3.5
                                        w-3.5
                                        transition-transform
                                        duration-300
                                        group-hover/button:translate-x-1
                                    "
                                />
                            </button>

                        </div>


                        {/* =================================================
                            DECORATIVE TEXT
                        ================================================= */}

                        <div
                            className="
                                pointer-events-none
                                absolute
                                right-[8%]
                                top-1/2
                                z-10
                                hidden
                                -translate-y-1/2
                                rotate-[-7deg]
                                opacity-90
                                lg:block
                                xl:right-[10%]
                            "
                        >
                            <div
                                className="
                                    font-serif
                                    text-[32px]
                                    italic
                                    leading-none
                                    text-white/90
                                "
                            >
                                Luxury
                            </div>

                            <div
                                className="
                                    -mt-1
                                    text-center
                                    font-serif
                                    text-[29px]
                                    italic
                                    leading-none
                                    text-[#E5C56D]
                                "
                            >
                                Awaits
                            </div>
                        </div>

                    </div>


                    {/* =================================================
                        BORDER
                    ================================================= */}

                    <div
                        className="
                            pointer-events-none
                            absolute
                            inset-0
                            z-20
                            rounded-[16px]
                            border
                            border-white/10
                        "
                    />

                </div>
            </div>
        </section>
    );
}